export const enSimularAhorro = {
    translation : {
        "Calcular ahorro - Banco" : "Calculate savings - Bank",
        "Calcular ahorro - Aseguradora" : "Calculate savings - Insurance company",
        "Calcular hipoteca" : "Calculate mortgage",
        "Calcular ahorro" : "Calculate savings",
        "Cargando..." : "Loading...",
        "Simular ahorro" : "Simulate savings",
    }
};